var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.412 24.5L0 23.088L9.881 13.207C10.0685 13.0195 10.1738 12.7652 10.1738 12.5C10.1738 12.2348 10.0685 11.9805 9.881 11.793L0.0170002 1.931L1.431 0.516998L11.293 10.379C11.8554 10.9416 12.1714 11.7045 12.1714 12.5C12.1714 13.2955 11.8554 14.0584 11.293 14.621L1.412 24.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a4986ce6d61ed89d6170336542b123fb.svg";
export { ForwardRef as ReactComponent };